import { useEffect } from "react";
import { useSearchParams } from "react-router";

import { useNavigation } from "@refinedev/core";

import { BottomActionBar } from "@/components/bottom-action-bar";
import { useDataFromClipboard } from "@/components/forms/load-from-clipboard/use-data-from-clipboard";
import { DeleteButton } from "@/components/refine-ui/buttons/delete";
import { Card, CardContent } from "@/components/ui/card";
import { cn } from "@/lib/utils";
import { EventCreateBasicInfo } from "@/pages/events/create/components/basic-info-step";
import { EventMediaStep } from "@/pages/events/create/components/media-step";
import { EventTicketingInfoStep } from "@/pages/events/create/components/ticketing-info-step";
import {
  Stepper,
  useEventCreateForm,
} from "@/pages/events/create/hooks/use-event-create-form";
import { EventBasicInfoType } from "@/pages/events/schemas/event.create.form";

export const EventCreate = () => (
  <Stepper.Provider variant="vertical">
    <EventCreateStepper />
  </Stepper.Provider>
);

const EventCreateStepper = () => {
  const { methods, updateBasicInfo, onInit } = useEventCreateForm();
  const [searchParams] = useSearchParams();
  const { list } = useNavigation();

  const { data } = useDataFromClipboard();

  useEffect(() => {
    if (!data) return;
    updateBasicInfo(data as EventBasicInfoType);
  }, [data, updateBasicInfo]);

  useEffect(() => {
    const id = searchParams.get("id");
    const clone = searchParams.get("clone");
    if (id) {
      onInit(id, clone === "true");
    }
  }, []);

  return (
    <div className="flex flex-col mb-20">
      <Stepper.Navigation>
        {methods.all.map((step) => (
          <Stepper.Step
            key={step.id}
            of={step.id}
            onClick={() => methods.goTo(step.id)}
          >
            <Stepper.Title>{step.title}</Stepper.Title>
            {step.description && (
              <Stepper.Description>{step.description}</Stepper.Description>
            )}
            <Stepper.Panel>
              <Card
                className={cn(
                  "p-4",
                  methods.current.id !== step.id ? "hidden" : "",
                )}
              >
                <CardContent className="p-0">
                  {methods.switch({
                    details: () => <EventCreateBasicInfo />,
                    ticketing: () => <EventTicketingInfoStep />,
                    media: () => {
                      return <EventMediaStep />;
                    },
                  })}
                </CardContent>
              </Card>
            </Stepper.Panel>
          </Stepper.Step>
        ))}
      </Stepper.Navigation>
      <BottomActionBar className="flex-row-reverse">
        {searchParams.get("id") && (
          <DeleteButton
            id={searchParams.get("id")!}
            onSuccess={() => list("events")}
          />
        )}
      </BottomActionBar>
    </div>
  );
};
